import Axios from "axios"
import { extend, forOwn } from "lodash"

window.axios = Axios
Axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest"

let _heartbeat_handler = null
Axios.interceptors.response.use(response => {
    // console.log("Axios.interceptors.response", response) // , response.request.responseText)
    if(response.data && response.data.meta && response.data.meta.csrf) Axios.defaults.headers.common["X-CSRF-TOKEN"] = response.data.meta.csrf

    if(response.data && response.data.redirect) window.location = response.data.redirect

    if(_heartbeat_handler && response.data && response.data.heartbeat_data) _heartbeat_handler(response.data.heartbeat_data)

    return Promise.resolve(response.data || response)
}, (error) => {
    return Promise.reject(error.response || error)
})
function fetch (url, data, method = "get") {
    let params = data
    if(method.match(/^(get|delete)$/i)) params = { params }
    return Axios[method](
        url,
        params
    )
}

export default {
    heartbeat_handler (handler) {
        _heartbeat_handler = handler
    },
    heartbeat () {
        return fetch("/private-api/heartbeat")
    },
    load_profile () {
        return fetch("/private-api/profile", { fields: ["fieldset::profile"] })
    },
    login (email, password) {
        return fetch("/private-api/login", { email, password, fields: ["fieldset::profile"] }, "post")
    },
    logout () {
        return fetch("/private-api/logout", {}, "post")
    },
    signup (data) {
        return fetch("/private-api/signup", data, "post")
    },
    send_password_reset (email) {
        return fetch("/private-api/password/email", { email }, "post")
    },
    reset_pasword (token, email, password, password_confirmation) {
        return fetch("/private-api/password/reset", {
            token,
            email,
            password,
            password_confirmation
        }, "post")
    },
    load_invitation (token) {
        return fetch("/private-api/user/invitation/" + token)
    },
    records_action (entity, action, data, method = "get") {
        return fetch(`/private-api/${entity}/${action}`, data, method)
    },
    records (entity, query) {
        return this.records_action(entity, "records", query)
    },
    record_action (entity, id, action, data, method = "get") {
        return fetch(`/private-api/${entity}/${id}/${action}`, data, method)
    },
    record_shell (entity) {
        return this.records_action(entity, "shell")
    },
    record_create (entity, data) {
        return this.records_action(entity, "create", data, "post")
    },
    record (entity, id, query) {
        return this.record_action(entity, id, "", query)
    },
    record_delete (entity, id, data) {
        return this.record_action(entity, id, "", data, "delete")
    },
    record_restore (entity, id, data) {
        return this.record_action(entity, id, "restore", data, "post")
    },
    record_save (entity, id, data) {
        return this.record_action(entity, id, "save", data, "post")
    },
    settings (data, path) {
        let url = "/private-api/settings"
        if(path) url = url + path
        if(data) return Axios.post(url, data)
        return fetch(url)
    },
    public_data (path, data) {
        if(data) return fetch("/api" + path, data, "post")
        return fetch("/api" + path, data)
    },
    snippet (slug) {
        return fetch("/private-api/snippet/by-slug/" + slug)
    },
    report_data (id, data) {
        return fetch("/private-api/report/" + id + "/data", data)
    },
    file_action (entity, id, action, name, file, progress, xtra_data, method = "post") {
        const config = {}
        const data = new FormData()

        if(file) {
            data.append(name, file)
            config.headers = { "content-type": "multipart/form-data" }
        } else data.append(name, true)
        if(xtra_data) Object.keys(xtra_data).forEach(key => data.append(key, xtra_data[key]))

        return this.record_action(entity, id, action || "attach", data, method)
    },
    autosuggest (context, query) {
        return fetch("/private-api/autosuggest/" + context, query)
    },
    fetch_records_at_path (path, query) {
        const data = extend({}, query)
        return fetch("/private-api/" + path, data)
    },
    record_field_save (entity, id, data) {
        return this.record_action(entity, id, "save", data, "post")
    },
    file_upload (entity, id, name, file, progress, task, xtra_data) {
        const data = new FormData()
        data.append(name, file)
        if(xtra_data) forOwn(xtra_data, (value, key) => data.append(key, value))
        const config = {
            headers: {
                "content-type": "multipart/form-data"
            }
        }

        let url = "/private-api/"
        url += entity + "/"
        if(id) url += id + "/"
        url += task || "attach"

        if(progress) config.onUploadProgress = progress

        return Axios.post(url, data, config)
    }
}
